define('presentation/common/protectedContent/viewModels/protectedContentViewModel',[],function() {
    return function() {
        const self = this;
        self.activate = () => {
        };
    };
});
